'use client'

import classNames from 'classnames'
import Link from 'next/link'
import { getCategoryUrl } from '@dustin-web/microsite-components/src/utils/urls'
import type { ProductPageType } from '@productsite-beta/src/components/product-page'
import {
  useOptimisticTitle,
  useOptimisticSpecs,
} from '../../../product-context/product-optimistic-context'

import './product-title.scss'

export type Props = {
  productName: string
  manufacturerName: string
  category: ProductPageType['category']
  productSpecifications: string
  isSmallScreen: boolean
}

const ProductTitle = ({
  productName,
  manufacturerName,
  category,
  productSpecifications,
  isSmallScreen,
}: Props) => {
  const { optimisticTitle } = useOptimisticTitle()
  const { optimisticSpecs } = useOptimisticSpecs()

  const displayedName = optimisticTitle ?? productName
  const productSpecsArray = (optimisticSpecs ?? productSpecifications)?.split('|')

  return (
    <div className="product-title">
      <Link
        href={`${getCategoryUrl(category?.pathSlug)}?manufacturer=${encodeURIComponent(
          manufacturerName.toLowerCase()
        )}`}
        className={classNames('h2 manufacturer', {
          h3: isSmallScreen,
        })}>
        {manufacturerName}
      </Link>
      <h1 className={classNames('d-flex flex-column u-m-0 h2', { h3: isSmallScreen })}>
        <span className="name">{displayedName}</span>
        <div className="specs">
          {productSpecsArray.map((spec: string, i: number) => (
            <span key={i}>{spec}</span>
          ))}
        </div>
      </h1>
    </div>
  )
}

export default ProductTitle
